<button type="button" class="btn btn-primary ms-2" (click)="open($event)">
    <i class="pi pi-sliders-h"></i> Columns
  </button>
  
  <p-overlayPanel #panel [showCloseIcon]="false" [dismissable]="true" styleClass="column-toggle-panel">
    <div class="column-toggle-list">
      <div
        class="column-toggle-item"
        *ngFor="let col of columns; trackBy: trackByKey"
        [class.disabled]="col.locked"
        (click)="onRowClick(col, $event)">
  
        <input
          type="checkbox"
          [checked]="col.visible"
          [disabled]="col.locked"
          tabindex="-1" />
        <span class="col-label">{{ col.header }}</span>
      </div>
    </div>
  </p-overlayPanel>